<template>
  <nav-bar/>

  <Title content="在线服务"/>
  <img src="~assets/img/admin/background.jpg" alt="" style="width: 100%; height: 50vh;">
  <!--新增科研信息-->
  <div class="title" :class="{isLetterSpace: showLang === 'zh'}">{{$t('title.在线服务')}}</div>
  <!--导航-->
  <SecNav ref="menus" :menu="menu" @menuClick="menuClick"/>

  <router-view></router-view>
  <Footer/>
</template>

<script>

  import NavBar from "@/components/common/NavBar";
  import Title from "@/components/common/Title";
  import SecNav from "@/components/common/SecNav";
  import Footer from "@/components/common/Footer";
  import { ref, reactive, getCurrentInstance, watch, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore, mapGetters } from 'vuex'

  export default {
    name: "index",
    components:{
      NavBar,
      Footer,
      Title,
      SecNav
    },
    computed:{
      ...mapGetters(['showCurrentIndex', 'showLang']),
    },
    setup(){

      const route = useRoute()
      const router = useRouter()
      const store = useStore()
      let instance = reactive({});
      instance = getCurrentInstance();
      // menu
      let menu = reactive([
        {name:'数据库', router: '/onlineService/database'},
        {name:'工具', router: '/onlineService/tools'},
      ]);
      //
      let currentMenu = ref('数据库');
      // methods
      // 页面刷新即跳转到'index'页
      window.onload = function () {
        router.push('/onlineService/database')
      };

      onMounted(() => {
        instance.proxy.$refs.menus.currentIndex = store.state.currentIndex;
        watch(()=>store.state.currentIndex, (newValue, oldValue) => {
          instance.proxy.$refs.menus.currentIndex = newValue;
        })
      })
      //methods
      function menuClick(menuName, addr) {
        currentMenu.value = menuName;
        router.push(addr)
      }
      /*bus.on('tiaozhuan', index => {
        instance.ctx.$refs.menus.currentIndex = index;
        //console.log('index = ', index)
      })*/

      return{ menu,
        menuClick,
      }
    }
  }
</script>

<style scoped lang="less">

  .title{
    font-size: 30px;
    color: #333333;
    line-height: 50px;
    text-align: center;
    padding: 40px 0 25px 0;
    //letter-spacing: 5px;
  }

  .isLetterSpace { letter-spacing: 5px; }

</style>